import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProjectManagerAxios } from "api/ProjectManagerAxios";
import { WarehouseAxios } from "api/WarehouseAxios";



export const fetchProjectManagerTaksAssignList = createAsyncThunk(
  "projectManager/fetchProjectManagerTaksAssignList",
  async ({ page, pageSize, sort, order, search, filters }: any) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) params.append("ordering", order === "desc" ? `-${sort}` : sort);

    if (filters && filters.length > 0) {
      filters.forEach((filter: { filterField: string; filterValue: any }) => {
        const { filterField, filterValue } = filter;
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
            });

            if (
              (filterValue.from_date || filterValue.to_date) &&
              (filterField === "created_at" || filterField === "updated_at")
            ) {
              const filterBy = filterField === "created_at" ? "created" : "updated";
              params.append("filter_by", filterBy);
            }
          } else {
            params.append(filterField, String(filterValue));
          }
        }
      });
    }

    const response = await ProjectManagerAxios.get(
      `/project-manager/task/sch_task/list/?${params.toString()}`
    );

    return {
      list: response.data?.data || [],
      rowCount: response.data?.count || 0,
      currentPage: response.data?.current_page || 1,
      totalPages: response.data?.total_pages || 1,
    };
  }
);


export const exportProjectManagerTasksCSV = async () => {
  const response = await ProjectManagerAxios.get(
    "/project-manager/manpower/export-to-excel/",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "tasks.csv",
  };
};



